module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/nailCare@3x_fa480d.png";